export const newUserData =
    {
        "username": "",
        "fullName": "",
        "authorities": [{"authority": "USER_ADMIN"}]
    }